import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var FlyingclubListingComponent = /** @class */ (function () {
    function FlyingclubListingComponent(businessManagerService) {
        this.businessManagerService = businessManagerService;
        this.isFlightDeckAdmin = false;
    }
    Object.defineProperty(FlyingclubListingComponent.prototype, "sortedClubs", {
        get: function () {
            if (!this.isFlightDeckAdmin) {
                return this.flyingClubs.filter(function (fc) { return !fc.hideBusiness; })
                    .filter(function (fc) { return !fc.notApproved; })
                    .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            return this.flyingClubs
                .sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    FlyingclubListingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return FlyingclubListingComponent;
}());
export { FlyingclubListingComponent };
